"use strict";
/**
 * @description 删除时保留 <p><br></p>
 * @author wangfupeng
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
/**
 * 删除时保留 <p><br></p>
 * @param editor 编辑器实例
 * @param deleteUpEvents delete 键 up 时的 hooks
 * @param deleteDownEvents delete 建 down 时的 hooks
 */
function deleteToKeepP(editor, deleteUpEvents, deleteDownEvents) {
    function upFn() {
        var $textElem = editor.$textElem;
        var txtHtml = $textElem.html().toLowerCase().trim();
        // firefox 时用 txtHtml === '<br>' 判断，其他用 !txtHtml 判断
        if (!txtHtml || txtHtml === '<br>') {
            // 内容空了
            var $p = dom_core_1.default('<p><br/></p>');
            $textElem.html(' '); // 一定要先清空，否则在 firefox 下有问题
            $textElem.append($p);
            editor.selection.createRangeByElem($p, false, true);
            editor.selection.restoreSelection();
        }
    }
    deleteUpEvents.push(upFn);
    function downFn(e) {
        var $textElem = editor.$textElem;
        var txtHtml = $textElem.html().toLowerCase().trim();
        if (txtHtml === '<p><br></p>') {
            // 最后剩下一个空行，就不再删除了
            e.preventDefault();
            return;
        }
    }
    deleteDownEvents.push(downFn);
}
exports.default = deleteToKeepP;
